export default {
    setInterestsList(state, payload){
            state.interestsList = payload;
    },

    setAlertStatus(state, payload) {
        state.alertStatus = payload;
    },    

    setProfileHome(state, payload) {
        state.profile.insure_building           = payload.insure_building;
        state.profile.insured_building_value    = payload.insured_building_value;
        state.profile.insure_household          = payload.insure_household;
        state.profile.insured_household_value   = payload.insured_household_value;
        state.profile.insure_portable_items     = payload.insure_portable_items;
        state.profile.insured_portable_value    =  payload.insured_portable_value;
        state.profile.insure_domestic_employees = payload.insure_domestic_employees;
        state.profile.indoor_employeers_num     = payload.indoor_employeers_num;
        state.profile.outdoor_employeers_num    = payload.outdoor_employeers_num;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js